import { LOGO } from 'Icon/logo'
import * as React from 'react'
import { Slink } from '../../routing/links'

export const LogoLink: React.FC = () => {
  return (
    <Slink name="home">
      <svg
        className="logo-smalldisplays"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 267 240"
      >
        {LOGO.smallLogo}
      </svg>
      <svg
        className="logo-bigdisplays"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 157 77"
      >
        {LOGO.bigLogo}
      </svg>
    </Slink>
  )
}
